import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './BookingPage.css';

const BookingPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { service, tier, price } = location.state || {};

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle booking submission here
    alert('Booking submitted successfully!');
    navigate('/#services');
  };

  return (
    <div className="booking-container">
      <div className="booking-form">
        <h2>Book {service}</h2>
        <h3>{tier} Package - {price}</h3>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <input type="text" placeholder="Full Name" required className="form-input" />
          </div>
          <div className="form-group">
            <input type="email" placeholder="Email" required className="form-input" />
          </div>
          <div className="form-group">
            <input type="tel" placeholder="Phone Number" required className="form-input" />
          </div>
          <div className="form-group">
            <textarea placeholder="Additional Requirements" className="form-input" rows="4"></textarea>
          </div>
          <button type="submit" className="cta-button">Confirm Booking</button>
        </form>
      </div>
    </div>
  );
};

export default BookingPage;
